import { motion } from "framer-motion";

const HERO_IMG =
    "https://images.pexels.com/photos/5563240/pexels-photo-5563240.jpeg?auto=compress&cs=tinysrgb&w=1920";

const fade = (delay) => ({
    initial: { opacity: 0, y: 28 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
});

const TrustDot = () => (
    <span className="h-1 w-1 rounded-full bg-brick" aria-hidden="true" />
);

export default function Hero() {
    return (
        <section id="top" data-testid="hero-section" className="relative flex min-h-screen items-end">
            <img
                src={HERO_IMG}
                alt="Çekim arkasında elinde kamerasıyla çalışan bir Bi Kadraj Media üyesi"
                className="absolute inset-0 h-full w-full object-cover"
                fetchpriority="high"
            />
            <div className="absolute inset-0 bg-ink/60" aria-hidden="true" />

            <div className="relative z-10 mx-auto w-full max-w-[1240px] px-6 pb-20 pt-40 md:px-10 md:pb-28">
                <motion.p
                    {...fade(0.05)}
                    data-testid="hero-trust-line"
                    className="flex flex-wrap items-center gap-x-3 gap-y-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-cream/80 sm:text-xs"
                >
                    <span>İçerik üretimi</span>
                    <TrustDot />
                    <span>Sosyal medya</span>
                    <TrustDot />
                    <span>Reklam</span>
                </motion.p>

                <motion.h1
                    {...fade(0.15)}
                    data-testid="hero-heading"
                    className="mt-6 max-w-4xl font-display text-[13.5vw] leading-[0.98] text-cream sm:text-6xl md:text-7xl lg:text-[5.5rem]"
                >
                    İşletmenizi doğru{" "}
                    <span className="border-b-[3px] border-brick">kadrajda</span>{" "}
                    gösteriyoruz.
                </motion.h1>

                <motion.p
                    {...fade(0.25)}
                    className="mt-6 max-w-xl text-base leading-relaxed text-cream/80 sm:text-lg"
                >
                    Çekimden paylaşıma, sosyal medya sürecinizi sade ve düzenli
                    şekilde yönetiyoruz.
                </motion.p>

                <motion.div {...fade(0.35)} className="mt-10 flex flex-col gap-3 sm:flex-row sm:gap-4">
                    <a
                        href="#calismalar"
                        data-testid="hero-cta-work"
                        className="inline-flex items-center justify-center bg-cream px-7 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-ink transition-colors hover:bg-white"
                    >
                        Çalışmaları Gör
                    </a>
                    <a
                        href="#iletisim"
                        data-testid="hero-cta-contact"
                        className="inline-flex items-center justify-center border border-cream/40 px-7 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-cream transition-colors hover:border-cream hover:bg-cream/5"
                    >
                        Bizimle İletişime Geç
                    </a>
                </motion.div>
            </div>
        </section>
    );
}
